var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5134_394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5623 5.42264L11.3123 1.30964C9.951 0.243141 8.04825 0.243141 6.687 1.30964L1.43775 5.42264C0.52425 6.13739 0 7.21364 0 8.37464V14.7496C0 16.8174 1.68225 18.4996 3.75 18.4996H14.25C16.3177 18.4996 18 16.8174 18 14.7496V8.37464C18 7.21364 17.4757 6.13814 16.5623 5.42264ZM9 14.7496C8.379 14.7496 7.875 14.2456 7.875 13.6246C7.875 13.0036 8.379 12.4996 9 12.4996C9.621 12.4996 10.125 13.0036 10.125 13.6246C10.125 14.2456 9.621 14.7496 9 14.7496ZM11.652 11.6589C11.5058 11.8051 11.3138 11.8786 11.1217 11.8786C10.9298 11.8786 10.7378 11.8051 10.5915 11.6589C9.714 10.7814 8.28675 10.7814 7.40925 11.6589C7.116 11.9521 6.642 11.9521 6.34875 11.6589C6.0555 11.3656 6.0555 10.8916 6.34875 10.5984C7.8105 9.13664 10.1903 9.13664 11.652 10.5984C11.9453 10.8916 11.9453 11.3656 11.652 11.6589ZM13.773 9.53714C13.6267 9.68339 13.4347 9.75689 13.2428 9.75689C13.0507 9.75689 12.8588 9.68339 12.7125 9.53714C10.6658 7.49039 7.335 7.49039 5.28825 9.53714C4.995 9.83039 4.521 9.83039 4.22775 9.53714C3.9345 9.24389 3.9345 8.76989 4.22775 8.47664C6.8595 5.84414 11.142 5.84414 13.7738 8.47664C14.067 8.76989 14.0662 9.24389 13.773 9.53714Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5134_394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.e74676d61f8188ef098de2511fda2e6b.svg";
export { ForwardRef as ReactComponent };